import {Component} from '@angular/core';

@Component({
    selector: 'app-create-user',
    templateUrl: './create-user.component.html',
    styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent {

    constructor() {
        window.scrollTo(0, 0);
    }

}
